import { actions } from './actions';

const defaultState = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  auth: {
    authToken: null,
  },
  features: {},
  config: {
    is_admin: false,
    is_super_admin: false,
    logo_url: false,
  },
  user_factory: null,
  tours: [],
  canceledBls: [],
  returnBls: [],
  vehicles: [],
  nav_width: 'expanded',
};

function reducers(state = defaultState, action) {
  switch (action.type) {
    case actions.AUTHENTICATE:
      return Object.assign({}, state, {
        auth: { isAuthenticated: true, authToken: action.token },
      });
    case actions.LOGOUT:
      return Object.assign({}, state, {
        auth: {
          isAuthenticated: false,
          authToken: null,
        },
        config: {},
      });
    case actions.SET_TOURS:
      return Object.assign({}, state, { tours: action.tours });
    case actions.FEATURES:
      return Object.assign({}, state, { features: action.features });
    case actions.CONFIG:
      return Object.assign({}, state, { config: action.config });
    case actions.USER_FACTORY:
      return Object.assign({}, state, { user_factory: action.user_factory });
    case actions.SET_VEHICLE_PIN:
      return Object.assign({}, state, {
        vehicles: state.vehicles.map((value) => {
          if (value.vehicule_id === action.vehicle_id) {
            return Object.assign({}, value, {
              pin: action.pin,
            });
          }
          return value;
        }),
      });
    case actions.SET_STEPS_FOR_A_TOUR:
      return Object.assign({}, state, {
        tours: state.tours.map((value) => {
          if (value.tour_id === action.tour_id) {
            return Object.assign({}, value, {
              steps: action.steps,
            });
          }
          return value;
        }),
      });
    case actions.SET_BLS_FOR_A_TOUR:
      return Object.assign({}, state, {
        tours: state.tours.map((value) => {
          if (value.tour_id === action.tour_id) {
            return Object.assign({}, value, {
              steps: value.steps.map((value2) => {
                if (value2.step_id === action.step_id) {
                  return Object.assign({}, value2, {
                    bls: action.bls,
                  });
                }
                return value2;
              }),
            });
          }
          return value;
        }),
      });
    case actions.VEHICLES:
      return Object.assign({}, state, { vehicles: action.vehicles });
    case actions.SET_NAV_WIDTH:
      return Object.assign({}, state, { nav_width: action.nav_width });
    default:
      return state;
  }
}

export default reducers;
